import { Component } from '@angular/core';
import { AlarmTableHeaderComponent } from '../alarm-table-header/alarm-table-header.component';

@Component({
    selector: 'app-alarm-table-header-compact',
    templateUrl: './alarm-table-header-compact.component.html',
    styleUrls: [
        '../alarm-table-header/alarm-table-header.component.scss',
        './alarm-table-header-compact.component.scss',
    ],
    standalone: false
})
export class AlarmTableHeaderCompactComponent extends AlarmTableHeaderComponent {}
